// This function allow to reference chunks
__webpack_require__.u = function(chunkId) {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + (chunkId === 615 ? "home" : chunkId) + "." + {615: "964d0044704b16d0",781: "489215a6b8de552b",}[chunkId] + ".js"
}